import { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { FaCubes, FaCheck } from "react-icons/fa";

import LocationsModal from "./locations-modal";

function LocationsForm({ master, loading, setLoading }) {
  const [showPopup, setShowPopup] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [data, setData] = useState([]);
  const [type, setType] = useState("");

  const getLocationsData = async () => {
    setLoading(true);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/exp_entries/location/acceptanceLocation`,
        { awb: master.resp.awb },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );

      if (res.data.code === 1) {
        setData(res.data.data);

        if (
          res.data.data.allHouses === null ||
          res.data.data.allHouses === undefined
        ) {
          setType("directa");
        } else if (
          Array.isArray(res.data.data.allHouses) &&
          res.data.data.allHouses.length > 0
        ) {
          setType("parcial");
        } else {
          setType("directa");
        }

        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching locations data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenModal = (id) => {
    setSelectedId(id);
    setShowPopup(true);
  };

  const save = () => {
    setLoading(true);

    setTimeout(() => {
      setLoading(false);

      Swal.fire({
        title: "Datos guardados con éxito",
        icon: "success",
        customClass: {
          confirmButton: "btn-ok",
          title: "alert-title",
          popup: "alert-bg",
        },
      });
    }, 1500); // ⏱ 1.5 segundos (ajústalo a gusto)
  };

  useEffect(() => {
    getLocationsData();
  }, []);

  if (!data || !data.resp) {
    return (
      <div className="container-fluid">
        <div className="alert alert-info">
          No hay datos de locaciones disponibles
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          {/* Directa */}
          {type === "directa" && (
            <table className="table mt-4">
              <thead className="text-center">
                <tr>
                  <th style={{ backgroundColor: "#020C41", color: "white" }}>
                    Master
                  </th>
                  <th style={{ backgroundColor: "#020C41", color: "white" }}>
                    Piezas
                  </th>
                  <th style={{ backgroundColor: "#020C41", color: "white" }}>
                    Peso
                  </th>
                  <th style={{ backgroundColor: "#020C41", color: "white" }}>
                    Bultos/Locs
                  </th>
                </tr>
              </thead>
              <tbody className="text-center">
                <tr>
                  <td>
                    {data.locaciones === "ready" && (
                      <FaCheck
                        style={{
                          fontWeight: "600",
                          fontSize: "13px",
                          marginRight: "5px",
                          cursor: "pointer",
                        }}
                      />
                    )}
                    {data.resp.awb || "N/A"}
                  </td>
                  <td>{data.resp.pieces || "N/A"}</td>
                  <td>{data.resp.weight || "N/A"}</td>
                  <td>
                    {/* Para directa, enviamos el ID del master */}
                    <button
                      className="btn"
                      onClick={() => handleOpenModal(data.resp.id)}
                    >
                      <FaCubes />
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          )}

          {/* Parcial */}
          {type === "parcial" && (
            <table className="table mt-4">
              <thead className="text-center">
                <tr>
                  <th style={{ backgroundColor: "#020C41", color: "white" }}>
                    Master
                  </th>
                  <th style={{ backgroundColor: "#020C41", color: "white" }}>
                    House
                  </th>
                  <th style={{ backgroundColor: "#020C41", color: "white" }}>
                    Piezas
                  </th>
                  <th style={{ backgroundColor: "#020C41", color: "white" }}>
                    Peso
                  </th>
                  <th style={{ backgroundColor: "#020C41", color: "white" }}>
                    Bultos/Locs
                  </th>
                </tr>
              </thead>
              <tbody className="text-center">
                <tr>
                  <td>{data.resp.awb || "N/A"}</td>
                  <td>-</td>
                  <td>{data.resp.pieces || "N/A"}</td>
                  <td>{data.resp.weight || "N/A"}</td>
                  <td></td>
                </tr>

                {data.allHouses?.map((house, index) => (
                  <tr key={index}>
                    <td></td>
                    <td>
                      {data.locaciones.includes(house.id) && (
                        <FaCheck
                          style={{
                            fontWeight: "600",
                            fontSize: "13px",
                            marginRight: "5px",
                            cursor: "pointer",
                          }}
                        />
                      )}
                      {house.hbs || "N/A"}
                    </td>
                    <td>{house.pieces || "N/A"}</td>
                    <td>{house.weight || "N/A"}</td>
                    <td>
                      <button
                        className="btn"
                        onClick={() => handleOpenModal(house.id)}
                      >
                        <FaCubes size={20} />
                      </button>
                    </td>
                  </tr>
                )) || (
                  <tr>
                    <td colSpan="5" className="text-center">
                      No hay houses disponibles
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}

          {type !== "directa" && type !== "parcial" && (
            <div className="alert alert-warning text-center mt-4">
              No se pudo determinar el tipo de carga (directa/parcial)
            </div>
          )}

          <div className="col-sm-12">
            <button className="btnn pull-right" onClick={(e) => save()}>
              Guardar
            </button>
          </div>
        </div>
      </div>

      {showPopup && (
        <LocationsModal
          master={master}
          locationsData={data}
          type={type}
          selectedId={selectedId}
          onClose={() => {
            setShowPopup(false);
            setSelectedId(null);
          }}
          loading={loading}
          setLoading={setLoading}
        />
      )}
    </>
  );
}

export default LocationsForm;
